import { cn } from '@/lib/utils'

export const ChatContainer: React.FC<{ className?: string; children: React.ReactNode }> = ({ className, children }) => {
  return <div className={cn('flex w-full flex-col gap-y-5', className)}>{children}</div>
}
